import { lazy } from "react";
import Loadable from "./Loadable";

export { default as AdminSidebar } from "./AdminSidebar";
export { default as LoaderOverlay } from "./LoaderOverlay";
export { default as DynamicPagination } from "./PaginationUI";
export { default as Loader } from "./Loader/Loader";
export { default as Loadable } from "./Loadable";
export const MinimalLayoutProvider = Loadable(
    lazy(() => import("./layout/MinimalLayout/MinimalLayoutProvider"))
);
export const MainLayoutWithProvider = Loadable(
    lazy(() => import("./layout/MainLayout/MainLayoutProvider"))
);
export { default as SearchComponent } from "./Search";

